// Ref: https://github.com/kentcdodds/react-hooks/blob/main/src/final/02.extra-4.js
import { useState, useEffect, useRef } from 'react';

export function useStorageState(
  storage,
  key,
  defaultValue = {},
  { serialize = JSON.stringify, deserialize = JSON.parse } = {}
) {
  storage = storage === 'localStorage' ? localStorage : sessionStorage;
  const [state, setState] = useState(() => {
    const valueInStorage = storage.getItem(key);
    if (valueInStorage) {
      // the try/catch is here in case the storage value was set before
      // we had the serialization in place (like we do in previous extra credits)
      try {
        return deserialize(valueInStorage);
      } catch (error) {
        storage.removeItem(key);
      }
    }
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
  });

  const prevKeyRef = useRef(key);

  useEffect(() => {
    const prevKey = prevKeyRef.current;
    if (prevKey !== key) {
      storage.removeItem(prevKey);
    }
    prevKeyRef.current = key;
    storage.setItem(key, serialize(state));
  }, [key, state, serialize]);

  return [state, setState];
}
